// Generated by CoffeeScript 2.7.0
var Admin__YetAnotherWorkflow__FlowsController, BasicCard, CollaboratorsCard, FlowActionCard, JourneysCard;

import CollaboratorsSelect from 'trunks/vue/admin/compositions/collaborators_select.js';

import LogicForm from 'trunks/vue/admin/compositions/logic_form.js';

import IconColorPicker from 'trunks/vue/admin/components/icon_color_picker.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import FlowMoreOperations from './concerns/flow_more_operations.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

import TagGroupSidebar from '../../share/tag_group_sidebar.js';

import TagsSelect from 'trunks/vue/admin/compositions/tags_select.js';

JourneysCard = class JourneysCard {
  constructor(element) {
    var switch_element;
    this.element = DomMaster.wrap(element);
    switch_element = new Skylark.Elements.Switch(this.element.find('.js-flow-status-switch'), {
      switchOnFunc: () => {
        this.confirm_popover || (this.confirm_popover = new Skylark.Elements.ConfirmPopover(DomMaster.find('.js-flow-status-popover'), {
          confirmFunc: this._doUpdate.bind(this, 'blocked'),
          dismissFunc: function() {
            return switch_element.change(false);
          }
        }));
        return this.confirm_popover.open();
      },
      switchOffFunc: () => {
        return this._doUpdate('active');
      }
    });
  }

  _doUpdate(status) {
    return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/journeys`, {
      contentType: 'application/json; charset=utf-8',
      responseType: 'script',
      data: {
        flow: {
          status: status
        }
      }
    });
  }

};

BasicCard = class BasicCard {
  constructor(element1) {
    var tag_ids_str;
    this.element = element1;
    this.element = DomMaster.wrap(this.element);
    this.tags_popover_el = this.element.find('.tags-popover');
    if (this.tag_ids == null) {
      this.tag_ids = _.isString(tag_ids_str = this.element.data('tag-ids')) ? _.compact(_.map(tag_ids_str.split(','), function(id) {
        return parseInt(id);
      })) : [];
    }
    this.element.node.proxy('click', '.js-tag-btn', () => {
      if (this.tags_popover == null) {
        this.tags_popover = new Skylark.Elements.Popover(this.tags_popover_el, {
          size: 'default',
          type: 'select',
          beforeOpenFunc: (popover) => {
            if (this.tag_select) {
              return this.tag_select.reset();
            } else {
              this.tag_select = new TagsSelect({
                el: this.element.find('.tags-edit-container').node,
                propsData: {
                  initialSelectedTagIds: this.tag_ids,
                  optionsUrl: '/tag_groups/yaw'
                }
              });
              return this.tag_select.$on('optionsChanged', function() {
                return popover.__calculatePosition();
              }).$on('cancelClicked', () => {
                return this.tags_popover.close();
              }).$on('submitClicked', function(value) {
                return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/basic`, {
                  contentType: 'application/json; charset=utf-8',
                  responseType: 'script',
                  data: {
                    flow: {
                      tag_ids: value
                    }
                  },
                  success: function() {
                    return newAlertify('更新成功', {
                      type: 'success'
                    });
                  }
                });
              });
            }
          }
        });
      }
      return this.tags_popover.open();
    });
  }

};

CollaboratorsCard = class CollaboratorsCard {
  constructor(element1) {
    var collaborator_ids_str;
    this.element = element1;
    this.element = DomMaster.wrap(this.element);
    this.collaborators_popover_el = this.element.find('.collaborators-popover');
    if (this.collaborator_ids == null) {
      this.collaborator_ids = _.isString(collaborator_ids_str = this.element.data('collaborator-ids')) ? _.compact(_.map(collaborator_ids_str.split(','), function(id) {
        return parseInt(id);
      })) : [];
    }
    this.element.node.proxy('click', '.js-collaborator-btn', (event) => {
      if (this.collaborators_popover == null) {
        this.collaborators_popover = new Skylark.Elements.Popover(this.collaborators_popover_el, {
          size: 'default',
          type: 'select',
          beforeOpenFunc: (popover) => {
            if (this.collaborators_select) {
              return this.collaborators_select.reset();
            } else {
              this.collaborators_select = new CollaboratorsSelect({
                el: this.element.find('.collaborators-edit-container').node,
                propsData: {
                  initialSelectedCollaboratorIds: this.collaborator_ids
                }
              });
              return this.collaborators_select.$on('optionsChanged', function() {
                return popover.__calculatePosition();
              }).$on('cancelClicked', () => {
                return this.collaborators_popover.close();
              }).$on('submitClicked', function(value) {
                return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/collaborators`, {
                  contentType: 'application/json; charset=utf-8',
                  responseType: 'script',
                  data: {
                    flow: {
                      collaborator_ids: value
                    }
                  }
                });
              });
            }
          }
        });
      }
      return this.collaborators_popover.open();
    });
  }

};

FlowActionCard = class FlowActionCard {
  constructor(element1) {
    this.element = element1;
    this.element = DomMaster.wrap(this.element);
    this._initEnableCustomElement();
    this.flow_id = this.element.data('flow-id');
    this._initActionsPopover();
    this.bindEvents();
  }

  bindEvents() {
    this.element.node.proxy('click', '.js-edit-icon', (event) => {
      return this.showIconColorPicker();
    });
    this.element.node.proxy('click', '.js-edit-tag', (event) => {
      var tag_ids_str;
      if (this.tag_ids == null) {
        this.tag_ids = _.isString(tag_ids_str = this.element.data('tag-ids')) ? _.compact(_.map(tag_ids_str.split(','), function(id) {
          return parseInt(id);
        })) : void 0;
      }
      return this.showTagSelect();
    });
    return this.element.node.proxy('click', '.js-back-to-list', (event) => {
      return this.showList();
    });
  }

  hideList() {
    this.actions_popover.switchSize('large');
    return this.action_list.hide();
  }

  showList() {
    this.actions_popover.switchSize('small');
    this.action_list.show();
    this.picker_container.hide();
    return this.tag_edit_container.hide();
  }

  showIconColorPicker() {
    this.picker_container.show();
    this.hideList();
    if (!this._icon_color_picker) {
      this._icon_color_picker = new IconColorPicker({
        el: this.picker_container.find('.js-icon-color-picker-el').node,
        propsData: {
          pickedIcon: this.element.data('icon'),
          pickedColor: this.element.data('bgcolor'),
          iconGroupLength: 6,
          pickerMode: 'all'
        }
      });
      this._icon_color_picker.$on('colorChanged', this._doUpdateCover.bind(this));
      return this._icon_color_picker.$on('iconChanged', this._doUpdateCover.bind(this));
    }
  }

  showTagSelect() {
    this.tag_edit_container.show();
    this.action_list.hide();
    new TagsSelect({
      el: this.tag_edit_container.find('.js-tag-edit-container-el').node,
      propsData: {
        optionsUrl: '/tag_groups/yaw',
        initialSelectedTagIds: this.tag_ids || []
      }
    }).$on('cancelClicked', () => {
      return this.showList();
    }).$on('submitClicked', (value) => {
      return Skylark.Libs.Ajax.patch(`/admin/yet_another_workflow/flows/${this.flow_id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          flow: {
            tag_ids: value
          }
        },
        success: () => {
          Skylark.Bridge.newAlertify('更新成功', {
            type: 'success'
          });
          this.actions_popover.close();
          return this.tag_ids = value;
        }
      });
    });
    return this.actions_popover.switchSize('large');
  }

  setCover(cover) {
    this._custom_icon_el.node.className = cover.icon;
    this._custom_icon_el.node.style.color = cover.bgcolor;
    return this._custom_bg_el.node.style.backgroundColor = cover.bgcolor;
  }

  _initEnableCustomElement() {
    var card_header;
    card_header = this.element.find('.card-header');
    this._custom_bg_el = card_header.find('.header-custom-bg');
    return this._custom_icon_el = card_header.find('i');
  }

  _initActionsPopover() {
    this.action_list = this.element.find('.list');
    this.picker_container = this.element.find('.js-picker-container');
    this.tag_edit_container = this.element.find('.js-tag-edit-container');
    this.actions_popover = new Skylark.Elements.Popover(this.element.find('.popover'), {
      size: 'small',
      beforeOpenFunc: (popover) => {
        return this.element.addClass('active');
      },
      beforeCloseFunc: () => {
        return this.element.removeClass('active');
      }
    });
    return this.actions_popover.open();
  }

  _doUpdateCover() {
    return Skylark.Libs.Ajax.patch(`/admin/yet_another_workflow/flows/${this.flow_id}`, {
      contentType: 'application/json; charset=utf-8',
      responseType: 'json',
      data: {
        flow: {
          cover: this._icon_color_picker.getData()
        }
      },
      success: (flow) => {
        return this.setCover(flow.cover);
      }
    });
  }

};

export default Admin__YetAnotherWorkflow__FlowsController = (function() {
  class Admin__YetAnotherWorkflow__FlowsController extends Skylark.App.BaseController {
    index() {
      var js_query_input;
      this.__toggleNavMenu();
      this.__bindEditTags('yaw');
      js_query_input = DomMaster.find('.js_query_input');
      if (js_query_input.isPresent()) {
        new Skylark.Elements.BasicQueryInput(js_query_input, {
          queryFunc: function(word) {
            var query_url;
            query_url = Skylark.Helpers.UrlHelper.generateUrlWithParams(location.href, {
              query: word
            });
            return window.location.replace(query_url);
          },
          cancelQueryFunc: function() {
            var query_url;
            query_url = Skylark.Helpers.UrlHelper.generateUrlWithParams(location.href, {
              query: ''
            });
            return window.location.replace(query_url);
          }
        });
      }
      return DomMaster.find('.main-content').node.proxy('click', '.flow-actions .trigger', function(event) {
        var base, flow_card_el;
        flow_card_el = DomMaster.wrap(event._target).closest('.flow-card');
        return (base = flow_card_el.node)._flow_card != null ? base._flow_card : base._flow_card = new FlowActionCard(flow_card_el);
      });
    }

    show() {
      this.__toggleNavMenu();
      this.cardsPatchUrl = `${location.pathname}/cards`;
      return this._initCards();
    }

    logic_settings() {
      var el, flow;
      this.__toggleNavMenu();
      flow = this.getVars('flow');
      if (!flow.fields.length) {
        return;
      }
      flow = new Skylark.App.Model.YetAnotherWorkflow.Flow(flow);
      el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('logic_form');
      this.logic_flow_view = new LogicForm({
        el: el,
        propsData: {
          formable: flow
        }
      });
      this.logic_flow_view.$on('logicSettingChanged', () => {
        return this._logicChanged = true;
      });
      this.logic_flow_view.$on('logicSaved', () => {
        return this._logicChanged = false;
      });
      return document.body.proxy('click', '.js_save_logic_settings', () => {
        return this.logic_flow_view.save();
      });
    }

    settings() {
      return this._initDropdownSelect();
    }

    beforeVisit(event, action) {
      if (action === 'logic_settings' && this._logicChanged) {
        event.preventDefault();
        return newConfirm({
          title: '您有更改未保存， 确定要离开吗',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).$on('ensureClicked', function() {
          return location.href = event.data.url;
        });
      }
    }

    _initCards() {
      this._initJourneysCard();
      this._initCollaboratorsCard();
      return this._initBasicCard();
    }

    _initJourneysCard() {
      return new JourneysCard(DomMaster.find('.js-journeys-card'));
    }

    _initBasicCard() {
      return new BasicCard(DomMaster.find('.js-basic-card'));
    }

    _initCollaboratorsCard() {
      var collaborators_card_el;
      collaborators_card_el = DomMaster.find('.js-collaborators-card');
      if (collaborators_card_el.isPresent()) {
        return new CollaboratorsCard(collaborators_card_el);
      }
    }

    _showBasicCard(content, global_id) {
      var element, modal_element, tag_ids, tag_ids_str;
      modal_element = Skylark.Elements.Modal.open(content, {
        modal_class_names: ['basic-modal'],
        beforeCloseFunc: function() {
          return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/basic`, {
            contentType: 'application/json; charset=utf-8',
            responseType: 'script',
            data: {
              _sync: true
            }
          });
        }
      });
      element = modal_element.find('.js-basic-modal');
      tag_ids = _.isString(tag_ids_str = element.data('tag-ids')) ? _.compact(_.map(tag_ids_str.split(','), function(id) {
        return parseInt(id);
      })) : [];
      return element.node.proxy('click', '.js-tag-btn', function(event) {
        var tags_popover;
        tags_popover = new Skylark.Elements.Popover(element.find('.tags-popover'), {
          size: 'default',
          type: 'select',
          beforeOpenFunc: function(popover) {
            var tag_select;
            tag_select = new TagsSelect({
              el: element.find('.tags-edit-container').node,
              propsData: {
                initialSelectedTagIds: tag_ids,
                optionsUrl: '/tag_groups/yaw'
              }
            });
            return tag_select.$on('optionsChanged', function() {
              return popover.__calculatePosition();
            }).$on('cancelClicked', function() {
              return tags_popover.close();
            }).$on('submitClicked', function(value) {
              return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/basic`, {
                contentType: 'application/json; charset=utf-8',
                responseType: 'script',
                data: {
                  way: 'modal',
                  flow: {
                    tag_ids: value
                  }
                }
              });
            });
          }
        });
        return tags_popover.open();
      });
    }

    _showCollaboratorsCard(content, global_id) {
      var collaborators_card, modal_element;
      modal_element = Skylark.Elements.Modal.open(content, {
        class_name: 'collaborators-card-table-modal',
        modal_class_names: ['large-modal'],
        beforeCloseFunc: function() {
          return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/collaborators`, {
            contentType: 'application/json; charset=utf-8',
            responseType: 'script',
            data: {
              _sync: true
            }
          });
        }
      });
      return collaborators_card = new Skylark.Elements.MessageCards.Collaborators(modal_element, global_id);
    }

    _showActivitiesCard(content) {
      var modal_element;
      modal_element = Skylark.Elements.Modal.open(content, {
        modal_class_names: ['message-activities-modal']
      });
      return new Skylark.Elements.Pagination(modal_element.find('.pagination'));
    }

    _doRepairFlow() {}

  };

  Admin__YetAnotherWorkflow__FlowsController.include(TagGroupSidebar, FlowMoreOperations, ToggleNavMenuAction);

  return Admin__YetAnotherWorkflow__FlowsController;

}).call(this);

Skylark.App.Controllers.register({Admin__YetAnotherWorkflow__FlowsController});
